import { useState, useEffect, useMemo } from "react";
import moment from "moment";
import DataGridGenerico from "../../../components/dataGrid/DataGridGenerico";
import { usePersistFilters } from "../../../hooks/usePersistFilters";
import { useGestionAsistencialColumns } from "../hooks/useGestionAsistencialColumns";
import { useGestionAsistencialInputs } from "../hooks/useGestionAsistencialInputs";
import { useGestionAsistencialRows } from "../hooks/useGestionAsistencialRows";
import { GestionAsistencialFiltersHeader } from "./GestionAsistencialFiltersHeader";

export const ID_ESTADO_PACIENTE_ALTA = 1;
const ID_ESTADO_PACIENTE_SERVICIO = 4;

export default function GestionAsistencialContent({allowedWrite}) {
  const [estadoPaciente, setEstadoPaciente] = useState([]);
  const [delegaciones, setDelegaciones] = useState([]);
  const [isRefetchRequired, setIsRefetchRequired] = useState(false);
  const [initialValues, setInitialValues] = useState({
    idDelegacion: 0,
    idEstadoPaciente: 0,
    fechaDesde: "",
    fechaHasta: "",
  });

  const { filters, handleChangeFilters } = usePersistFilters(
    {
      idDelegacion: 0,
      txtFiltro: "",
      idEstadoPaciente: ID_ESTADO_PACIENTE_SERVICIO,
      fechaDesde: moment().add(-10, "d").format("yyyy-MM-DD"),
      fechaHasta: moment().add(20, "d").format("yyyy-MM-DD"),
    },
    "AsistencialFilters"
  );

  const nombreDelegacion = useMemo(
    () =>
      delegaciones?.find((d) => d.id === filters?.idDelegacion)?.displayName,
    [filters?.idDelegacion, delegaciones]
  );

  const columns = useGestionAsistencialColumns(
    estadoPaciente,
    delegaciones,
    nombreDelegacion,
    filters?.idDelegacion,
    allowedWrite
  );

  const resetInitialValues = () => {
    setInitialValues({
      idDelegacion: filters.idDelegacion,
      idEstadoPaciente: filters.idEstadoPaciente,
      fechaDesde: filters.fechaDesde,
      fechaHasta: filters.fechaHasta,
    });
    setIsRefetchRequired(false);
  };

  const {
    rows,
    setRows,
    originalData,
    totalCount,
    loading,
    handleSearch,
    applyClientSideFilters,
  } = useGestionAsistencialRows({
    filters,
    handleChangeFilters,
    resetInitialValues,
    estadoPaciente
  });

  const { handleChange, handleChangeFechaDesde, handleChangeFechaHasta } =
    useGestionAsistencialInputs({
      handleChangeFilters,
      initialValues,
      setIsRefetchRequired,
    });

  const handleTextFilter = () => {
    const data = applyClientSideFilters(
      originalData,
      filters.txtFiltro,
    );
    setRows(data);
  };

  const handleTextClean = () => {
    handleChangeFilters("txtFiltro", "");
    const data = applyClientSideFilters(
      originalData,
      "",
    );
    setRows(data);
  };

  const handleEstadoPacienteFilter = (newEstadoPaciente) => {
    // if (isRefetchRequired) return;

    // if (
    //   newEstadoPaciente === ID_ESTADO_PACIENTE_ALTA ||
    //   initialValues.idEstadoPaciente === ID_ESTADO_PACIENTE_ALTA
    // ) {
    setRows([]);
    setIsRefetchRequired(true);
    //   return;
    // }

    // const data = applyClientSideFilters(
    //   originalData,
    //   filters.txtFiltro,
    //   newEstadoPaciente
    // );
    // setRows(data);
  };

  const handleDelegacionChange = (event) => {
    const newDelegacion = event.target.value;
    handleChange(event);

    if (newDelegacion !== initialValues.idDelegacion) {
      setIsRefetchRequired(true);
      setRows([]);
      return;
    }

    setIsRefetchRequired(false);
  };

  useEffect(() => {
    setInitialValues({
      idDelegacion: filters.idDelegacion,
      idEstadoPaciente: filters.idEstadoPaciente,
      fechaDesde: filters.fechaDesde,
      fechaHasta: filters.fechaHasta,
    });
  }, []);

  return (
    <div className="grid-container requisitos-clientes-grilla">
      <GestionAsistencialFiltersHeader
        filters={filters}
        handleChange={handleChange}
        handleTextClean={handleTextClean}
        handleTextFilter={handleTextFilter}
        handleSearch={handleSearch}
        handleEstadoPacienteFilter={handleEstadoPacienteFilter}
        handleDelegacionChange={handleDelegacionChange}
        handleChangeFechaDesde={handleChangeFechaDesde}
        handleChangeFechaHasta={handleChangeFechaHasta}
        estadoPaciente={estadoPaciente}
        delegaciones={delegaciones}
        setDelegaciones={setDelegaciones}
        setEstadoPaciente={setEstadoPaciente}
      />
      <DataGridGenerico
        columns={columns}
        totalCount={totalCount}
        rows={rows}
        toolbar={false}
        loading={loading}
        localeText={{
          noRowsLabel: isRefetchRequired
            ? 'Haz click en "Buscar" para aplicar los nuevos filtros'
            : "Sin filas",
        }}
      />
    </div>
  );
}
